// LED de estado estilo tablero: punto de color + label opcional.
// `tone` mapea semántica → color; `pulse` para estados "vivos" (polling, activo).

export type LedTone = 'success' | 'warning' | 'error' | 'info' | 'idle';

const TONE_CLASS: Record<LedTone, string> = {
  success: 'bg-status-success shadow-[0_0_6px_rgba(74,222,128,0.8)]',
  warning: 'bg-status-warning shadow-[0_0_6px_rgba(251,191,36,0.8)]',
  error: 'bg-status-error shadow-[0_0_6px_rgba(248,113,113,0.8)]',
  info: 'bg-status-info shadow-[0_0_6px_rgba(56,189,248,0.8)]',
  idle: 'bg-status-idle',
};

/** Mapea estados del dominio a un tono de LED. */
export function toneForStatus(status: string): LedTone {
  switch (status) {
    case 'active':
    case 'succeeded':
    case 'current':
    case 'approved':
    case 'trialing':
      return 'success';
    case 'grace_period':
    case 'grace':
    case 'pending':
    case 'rotated':
      return 'warning';
    case 'blocked':
    case 'deactivated':
    case 'failed':
    case 'expired':
    case 'revoked':
      return 'error';
    case 'consumed':
    case 'refunded':
    case 'cancelled':
      return 'info';
    default:
      return 'idle';
  }
}

export function StatusLed({
  tone,
  pulse = false,
  label,
}: {
  tone: LedTone;
  pulse?: boolean;
  label?: string;
}) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        aria-hidden="true"
        className={`inline-block h-2 w-2 rounded-full ${TONE_CLASS[tone]} ${pulse ? 'animate-led-pulse' : ''}`}
      />
      {label !== undefined && <span className="uppercase tracking-wider">{label}</span>}
    </span>
  );
}

/** Badge de status con LED — para celdas de tabla. */
export function StatusBadge({ status }: { status: string }) {
  return (
    <span className="inline-flex items-center gap-1.5 text-[11px]">
      <StatusLed tone={toneForStatus(status)} />
      <span className="uppercase tracking-wide">{status}</span>
    </span>
  );
}
